import React from 'react';
import s from './CheckboxList.scss';
import classNames from 'classnames';

export interface ICheckboxListProps {
  options: {id: string; name: string}[];
  selected: string[];
  onChange: Function;
  id: string;
  dataHook: string;
}

export enum CheckboxListDataHooks {
  Input = 'input',
  Label = 'label',
}

export class CheckboxList extends React.Component<ICheckboxListProps> {
  public render() {
    const {options, selected, onChange, dataHook} = this.props;
    return (
      <ul className={s.options} data-hook={dataHook}>
        {options.map((option) => (
          <li key={option.id}>
            <input
              checked={selected.includes(option.id)}
              className={s.checkbox}
              data-hook={CheckboxListDataHooks.Input}
              type="checkbox"
              id={`${this.props.id}${option.id}`}
              value={option.id}
              onChange={(e) => onChange(e)}
            />
            <label
              className={classNames('wixSdkShowFocusOnSibling', s.label)}
              data-hook={CheckboxListDataHooks.Label}
              htmlFor={`${this.props.id}${option.id}`}>
              <span className={s.labelText}>{option.name}</span>
            </label>
          </li>
        ))}
      </ul>
    );
  }
}
